<app-modal-frame [headerText]="CONST.HEADER" (emitExit)="onExit()">
  <div class="card-content">
    <!-- Row 1-->
    <ion-row class="wrapper">
      <!-- Tracking Number -->
      <ion-col [size]="colSize">
        <div class="profile-headers">{{ CONST.LABELS.TRACKING_NUMBER }}</div>
        <div class="profile-values">
          {{ statusData.trackingNumber }}
        </div>
      </ion-col>

      <!-- Reason -->
      @if (isSmartValue) {
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.REASON }}</div>
          <div class="profile-values">
            {{ statusData.reason }}
          </div>
        </ion-col>
      }

      <!-- Equipment Number -->
      <ion-col [size]="colSize">
        <div class="profile-headers">{{ CONST.LABELS.EQUIPMENT_NUMBER }}</div>
        <div class="profile-values">
          {{ statusData.equipmentNumber }}
        </div>
      </ion-col>

      <!-- Scan Time -->
      <ion-col [size]="colSize">
        <div class="profile-headers">{{ CONST.LABELS.SCAN_TIME }}</div>
        <div class="profile-values">
          {{ statusData.scanTime }}
        </div>
      </ion-col>
    </ion-row>

    <!-- Row 2-->
    <ion-row class="wrapper">
      @if (isSmartValue) {
        <!-- Destination Country -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.DESTINATION }}</div>
          <div class="profile-values">
            {{ statusData.destination }}
          </div>
        </ion-col>

        <!-- Sort Code -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.SORT_CODE }}</div>
          <div class="profile-values">
            {{ statusData.sortCode }}
          </div>
        </ion-col>
      }

      <!-- Equipment Type-->
      <ion-col [size]="colSize">
        <div class="profile-headers">{{ CONST.LABELS.EQUIPMENT_TYPE }}</div>
        <div class="profile-values">
          {{ statusData.equipmentType }}
        </div>
      </ion-col>

      <!-- Movement -->
      <ion-col [size]="colSize">
        <div class="profile-headers">{{ CONST.LABELS.MOVEMENT }}</div>
        <div class="profile-values">
          {{ statusData.movement }}
        </div>
      </ion-col>

      @if (!isSmartValue) {
        <ng-container *ngTemplateOutlet="userIdView"></ng-container>
      }
    </ion-row>

    <!-- Row 3-->
    <ion-row class="wrapper">
      @if (isSmartValue) {
        <!-- User ID -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.USER_ID }}</div>
          <div class="profile-values">
            {{ statusData.userId }}
          </div>
        </ion-col>
      }

      <!-- Load Chart -->
      <ion-col [size]="colSize">
        <div class="profile-headers">{{ CONST.LABELS.LOAD_CHART }}</div>
        <div class="profile-values">
          {{ statusData.loadChart }}
        </div>
      </ion-col>
      @if (isSmartValue) {
        <!-- Status -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.STATUS }}</div>
          <div class="profile-values">
            {{ statusData.status }}
          </div>
        </ion-col>

        <!-- Sort Date -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.SORT_DATE }}</div>
          <div class="profile-values">
            {{ statusData.sortDate }}
          </div>
        </ion-col>
      } @else {
        <ng-container *ngTemplateOutlet="destLoadKeyView"></ng-container>
      }
    </ion-row>

    <!-- Row 4-->
    @if (isSmartValue) {
      <ion-row class="wrapper">
        <ng-container *ngTemplateOutlet="destLoadKeyView"></ng-container>
        <!-- Flex -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.FLEX }}</div>
          <div class="profile-values">
            {{ statusData.flex }}
          </div>
        </ion-col>

        <!-- Child Load Chart -->
        <ion-col size="3">
          <div class="profile-headers">{{ CONST.LABELS.CHILD_LOAD }}</div>
          <div class="profile-values">
            {{ statusData.childLoad }}
          </div>
        </ion-col>
      </ion-row>
    }

    <ng-template #userIdView>
      <!-- User ID -->
      <ion-col [size]="colSize">
        <div class="profile-headers">{{ CONST.LABELS.USER_ID }}</div>
        <div class="profile-values">
          {{ statusData.userId }}
        </div>
      </ion-col>
    </ng-template>

    <ng-template #destLoadKeyView>
      <!-- Dest Load Key -->
      <ion-col [size]="colSize">
        <div class="profile-headers">{{ CONST.LABELS.LOAD_KEY }}</div>
        <div class="profile-values">
          {{ statusData.loadKey }}
        </div>
      </ion-col>
    </ng-template>
  </div>
</app-modal-frame>
